import { render } from "./mvt-popownup.vue?vue&type=template&id=5b741385&lang=html"
import script from "./mvt-popownup.js?vue&type=script&lang=js"
export * from "./mvt-popownup.js?vue&type=script&lang=js"

import "./mvt-popownup.vue?vue&type=style&index=0&id=5b741385&lang=scss"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__